var cov_26u2jwfu2g = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Rule/length.ts",
      hash = "a40147da5efb4c76c85f180702fa17c9b9e68367",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Rule/length.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 22
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 46
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "2": {
        start: {
          line: 8,
          column: 11
        },
        end: {
          line: 8,
          column: 13
        }
      },
      "3": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 19,
          column: 3
        }
      },
      "4": {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 12,
          column: 19
        }
      },
      "5": {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 13,
          column: 11
        }
      },
      "6": {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 18
        }
      },
      "7": {
        start: {
          line: 16,
          column: 6
        },
        end: {
          line: 16,
          column: 11
        }
      },
      "8": {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 18,
          column: 19
        }
      },
      "9": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 21,
          column: 66
        }
      },
      "10": {
        start: {
          line: 24,
          column: 16
        },
        end: {
          line: 24,
          column: 39
        }
      },
      "11": {
        start: {
          line: 26,
          column: 29
        },
        end: {
          line: 29,
          column: 1
        }
      },
      "12": {
        start: {
          line: 31,
          column: 84
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "13": {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 38,
          column: 3
        }
      },
      "14": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 86
        }
      },
      "15": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 15
        }
      },
      "16": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 43,
          column: 3
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 22
          },
          end: {
            line: 7,
            column: 23
          }
        },
        loc: {
          start: {
            line: 7,
            column: 46
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 46
          },
          end: {
            line: 7,
            column: 47
          }
        },
        loc: {
          start: {
            line: 7,
            column: 69
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 31,
            column: 15
          },
          end: {
            line: 31,
            column: 16
          }
        },
        loc: {
          start: {
            line: 31,
            column: 84
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 31
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 31,
            column: 84
          },
          end: {
            line: 31,
            column: 85
          }
        },
        loc: {
          start: {
            line: 34,
            column: 5
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 34
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 10,
            column: 19
          }
        }, {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 13,
            column: 11
          }
        }, {
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 16,
            column: 11
          }
        }, {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 18,
            column: 19
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 31,
            column: 36
          },
          end: {
            line: 31,
            column: 79
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 31,
            column: 77
          },
          end: {
            line: 31,
            column: 79
          }
        }],
        line: 31
      },
      "2": {
        loc: {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        }, {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        }],
        line: 35
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _defineProperty from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { deepMerge } from '../utils/objects';
import { substitute } from '../utils/strings';
import { getLocale } from '../locale';
cov_26u2jwfu2g.s[0]++;

var createMessage = function createMessage(key) {
  cov_26u2jwfu2g.f[0]++;
  cov_26u2jwfu2g.s[1]++;
  return function (props) {
    cov_26u2jwfu2g.f[1]++;
    var lt = (cov_26u2jwfu2g.s[2]++, '');
    cov_26u2jwfu2g.s[3]++;

    switch (props.type) {
      case 'integer':
        cov_26u2jwfu2g.b[0][0]++;

      case 'number':
        cov_26u2jwfu2g.b[0][1]++;
        cov_26u2jwfu2g.s[4]++;
        lt = 'number';
        cov_26u2jwfu2g.s[5]++;
        break;

      case 'array':
        cov_26u2jwfu2g.b[0][2]++;
        cov_26u2jwfu2g.s[6]++;
        lt = 'array';
        cov_26u2jwfu2g.s[7]++;
        break;

      default:
        cov_26u2jwfu2g.b[0][3]++;
        cov_26u2jwfu2g.s[8]++;
        lt = 'string';
    }

    cov_26u2jwfu2g.s[9]++;
    return substitute(getLocale("rules.length.".concat(key, ".").concat(lt)), props);
  };
};

var options = (cov_26u2jwfu2g.s[10]++, {
  skipUndefined: true
});
export var lengthMessage = (cov_26u2jwfu2g.s[11]++, {
  max: createMessage('max'),
  min: createMessage('min')
});
export default (function (key) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_26u2jwfu2g.b[1][0]++, {}),
      message = _ref.message;

  cov_26u2jwfu2g.f[2]++;
  cov_26u2jwfu2g.s[12]++;
  return function (len, msg) {
    cov_26u2jwfu2g.f[3]++;
    cov_26u2jwfu2g.s[13]++;

    if (typeof len !== 'number') {
      cov_26u2jwfu2g.b[2][0]++;
      cov_26u2jwfu2g.s[14]++;
      console.error(new Error("Rule \"".concat(key, "\" param expect a number, get ").concat(typeof len)));
      cov_26u2jwfu2g.s[15]++;
      return null;
    } else {
      cov_26u2jwfu2g.b[2][1]++;
    }

    cov_26u2jwfu2g.s[16]++;
    return deepMerge({
      message: lengthMessage[key]
    }, deepMerge(_defineProperty({
      message: message
    }, key, len), {
      message: msg
    }, options), options);
  };
});